import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { styled, SxProps, Theme } from '@mui/material';
import { useEffect, useState, useContext } from 'react';
import { ModalContext } from '../../provider/ModalProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface ModalDefaultProps {
  visible: boolean;
  children: React.ReactNode;
  isNotBoxShadow?: boolean;
  opacity?: number;
  onClose: () => void;
  overflow?: boolean;
  containerOverflow?: string;
  sx?: SxProps<Theme>;
  zIndex?: string;
  isAccountSms?: boolean;
  zoomFalse?: boolean;
  isAlert?: boolean;
  isNested?: boolean;
}

const CustomModal = styled(Modal)(({ theme }) => ({
  '& > .MuiBox-root': {
    '&:focus-visible': {
      outline: 'none',
    },
  },
}));

interface StyledBoxProps {
  $is_not_box_shadow?: boolean;
  isAlert?: boolean;
}

const StyledBox = styled(Box)<StyledBoxProps>(props => ({
  overflow: 'hidden',
  position: 'absolute',
  top: props.isAlert ? '18.8%' : '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  height: 'auto',
  boxShadow: 'none',
}));

function ModalDefault(props: ModalDefaultProps) {
  // const { setRootState } = useContext(ModalContext);
  const user_info = useSelector((state: RootState) => state.UserReducer);

  const visible = props.visible;
  const children = props.children;
  const onClose = props.onClose;
  const is_not_box_shadow = props.isNotBoxShadow;
  const props_opacity = props.opacity;
  const overflow = props.overflow;
  const container_overflow = props.containerOverflow;
  const sx = props.sx;
  const zIndex = props.zIndex;
  const isAccountSms = props.isAccountSms ? props.isAccountSms : false;
  const isNested = props.isNested;

  const [curOpacity, setCurOpacity] = useState(46);
  const [overflowX, setOverflowX] = useState(false);

  useEffect(() => {
    const modals = document.getElementsByClassName('modal_default');
    if (visible) {
      setOpacity(modals.length + 1);
    } else {
      setOpacity(modals.length);
    }
    // setRootState(visible);
    setTimeout(() => {
      setModalScrollPosition();
    }, 0);
  }, [visible]);

  const setModalScrollPosition = () => {
    const modal_default = document.getElementById('modal_default');

    if (modal_default) {
      if (document.body.getBoundingClientRect().width < modal_default.scrollWidth) {
        setOverflowX(true);
        const gap = modal_default.scrollWidth - document.body.getBoundingClientRect().width;
        modal_default.scrollTo({
          left: gap / 2,
          behavior: 'smooth',
        });
      }
    }
  };

  const setOpacity = (length: number) => {
    let cur_opacity = 0;
    if (length == 1) {
      cur_opacity = props_opacity ? props_opacity : 46;
    } else {
      cur_opacity = 4 - length;
    }
    setCurOpacity(cur_opacity);
  };

  const onFocusModal = (event: React.FocusEvent<HTMLDivElement>) => {
    event.currentTarget.blur();
  };

  return (
    <CustomModal
      open={visible}
      id='modal_default'
      className='modal_default'
      BackdropProps={{
        // sx: {
        //   '&.MuiBackdrop-root:not(.MuiBackdrop-invisible)': {
        //     opacity: props_opacity && props_opacity === 0 ? '0 !important' : '',
        //   },
        //   backgroundColor: `rgba(33, 33, 33, 0.${props_opacity ? props_opacity : curOpacity})`,
        //   transition: '0.2s cubic-bezier(0.25, 0.8, 0.5, 1), z-index 1ms !important',
        // },
        sx: {
          '&.MuiBackdrop-root:not(.MuiBackdrop-invisible)': {
            opacity: isNested ? '0 !important' : props_opacity === 0 ? '0 !important' : '',
          },
          backgroundColor: isNested
            ? 'transparent'
            : `rgba(33, 33, 33, 0.${props_opacity !== undefined ? props_opacity : curOpacity})`,
          transition: '0.2s cubic-bezier(0.25, 0.8, 0.5, 1), z-index 1ms !important',
        },
      }}
      sx={{
        zIndex: zIndex ?? 1300,
        width: '100vw',
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Box
        onClick={() => {
          !isAccountSms ? onClose() : null;
        }}
        sx={{
          zoom: props.zoomFalse ? '100%' : `${user_info.zoom_status}%`,
          width: '100%',
          height: '100%',
          position: 'relative',
          minWidth: overflowX ? '860px' : 'unset',
          minHeight: overflowX ? '500px' : 'unset',
        }}
      >
        <StyledBox
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            // e.preventDefault();
            e.stopPropagation();
          }}
          $is_not_box_shadow={is_not_box_shadow}
          id='modal_default_container'
          sx={sx ? sx : { overflow: container_overflow ? container_overflow : overflow ? 'unset' : 'unset' }}
          isAlert={props.isAlert}
        >
          {children}
        </StyledBox>
      </Box>
    </CustomModal>
  );
}

export default ModalDefault;
